module.exports = {"621225100":"汉源镇","621225101":"长道镇","621225102":"何坝镇","621225103":"姜席镇","621225104":"石峡镇","621225105":"洛峪镇","621225106":"西峪镇","621225107":"马元镇","621225108":"大桥镇","621225201":"石堡乡","621225203":"苏河乡","621225204":"卢河乡","621225205":"兴隆乡","621225206":"稍峪乡","621225208":"晒经乡","621225211":"十里乡","621225217":"蒿林乡","621225218":"太石河乡","621225220":"六巷乡","621225221":"西高山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621225.json
// module id = 2746
// module chunks = 0